import api from '../services/api'

export default {

    namespaced: true,
    state: {
        token: null,
        user: null,
        isMenuVisible: false,
        loading: false
    },

    mutations: {

        toggleMenu(state, isVisible){
            if(!state.user) {
                state.isMenuVisible = false
                return
            }
            state.isMenuVisible = isVisible
        },
        setUser(state, user){
            state.user = user
            if(user){
                // Set authorization header
                api.defaults.headers.common['Authorization'] = `bearer ${user.token}`
                state.isMenuVisible = true

                // Persist to localStorage
                localStorage.setItem('authUser', JSON.stringify(user))
            } else {
                // Clear authorization
                delete api.defaults.headers.common['Authorization']
                state.isMenuVisible = false

                // Clear localStorage
                localStorage.removeItem('authUser')
            }
        },
        setLoading(state, valor){
            state.loading = valor
        }
    },

    actions: {
        restoreSession({ commit }) {
            const authUser = localStorage.getItem('authUser')

            if (authUser) {
                try {
                    const user = JSON.parse(authUser)
                    commit('setUser', user)
                    return true
                } catch (error) {
                    localStorage.removeItem('authUser')
                    return false
                }
            }

            return false
        }
    }

}